<div class="h-full w-full relative bg-surface-container-lowest">
    <mat-icon svgIcon="login_background"
        class="absolute w-full h-screen bg-repeat bg-surface-container-lowest pointer-events-none">
    </mat-icon>

    <div class="flex flex-col  items-center justify-center h-full relative z-10">
        <div class="flex-row  rounded-[5px] border-[1px] border-outline-variant h-[620px]">
            <div class="flex flex-col w-[360px] h-full justify-between rounded py-8 px-4 bg-surface-container-lowest">
                <div class="flex flex-col gap-y-4 items-center">
                    <mat-icon svgIcon="ic_sbox_brackets" class="h-[50px] w-[50px]"></mat-icon>
                    <div class="flex flex-col gap-y-2 items-center text-center justify-center">
                        <p class="mat-title-large text-on-surface ">Check your email</p>
                        <p class=" mat-body-large text-on-surface-variant text-center self-center ">
                            We've sent a password reset link to your email (<span
                                class="mat-title-medium text-on-surface">{{email}}</span>). If it doesn't appear within
                            a few minutes, please check your spam folder.
                        </p>
                    </div>
                </div>

                <div class="justify-center flex flex-col gap-y-4">
                    <button mat-flat-button class="w-full" (click)="navigateToLogin()"
                        [id]="'navigateToLoginButton'">Return
                        to Log In</button>
                </div>
            </div>
        </div>
    </div>

</div>